import { ProductsAdditionalInfo } from "./products-additional-info-model";

export class PublicLocation {
  id!: string;
  name!: string;
  locationId!: string;
  longitude!: number;
  latitude!: number;
  address!: string
  postalCode!: string;
  city!: string;
  country!: string;
  stopTime!: string;
  isInfrastructure?: boolean;
  productsAdditionalInfo!: ProductsAdditionalInfo[];
  segment!: string;
  tenantLocationId!: string;
  label?: string;
}
